import { styled } from "@mui/material/styles";

export const LoginContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(4),
  width: "100%",
  padding: "40px",
  alignItems: "center",
  "& .full-background": {
    display: "none",
    "& img": {
      borderRadius: "20px",
      maxWidth: "100%",
      height: "auto",
    },
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  "& > div": {
    width: "100%",
  },
  "& .login-form": {
    maxWidth: "360px",
    margin: "0 auto 30px auto",

    "& h1": {
      fontSize: "clamp(1rem, 1rem + 2vw, 1.875rem)",
      fontWeight: 600,
      margin: "2rem 0 0.3rem 0",
      textAlign: "center",
    },
    "& > img": {
      width: "67px",
      margin: "0 auto",
      display: "flex",
    },
    "& > p": {
      margin: "0 0 2rem 0",
      textAlign: "center",
      fontWeight: "normal",
      opacity: .8
    },
    "& .login-utils": {
      display: "none", //flex
      marginBottom: "1rem",
      fontSize: "12px",
      justifyContent: "space-between",
      alignItems: "center",
      "& .remember-me": {
        "& .input-field": {
          display: "flex",
          alignItems: "center",
          marginBottom: "0",
          "& label": {
            marginBottom: 0,
            fontSize: "12px",
            display: "flex",
            alignItems: "center"
          },
          "& input": {
            marginRight: "8px",
          }
        }
      },
      "& .forgot-link": {
        color: "#D1C7FF",
        textDecoration: "none"   
      }
    },
    "& .input-field": {
      marginBottom: "1.2em",
      "& label": {
        fontSize: "14px",
        marginBottom: "5px",
        display: "inline-block"
      }
    },
    "& button": {
      display: "block",
      width: "100%",
      padding: "12px 20px",
      "& p": {
        fontSize: "16px"
      }
    },
  },
  "& .register-helper": {
    display: "none",
    marginTop: "2rem",
    textAlign: "center",
    fontSize: "14px",
    "& a": {
      color: "#D1C7FF",
      textDecoration: "none"
    }
  },
}));
